import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(private http: HttpClient) { }

  saveMember(id:any, payload: any) {
        if (id) {
          return this.http.patch(urls.API_URL + urls.MEMBERS + `/${id}`, payload)
            .pipe(catchError(errorHandl));
        }
    return this.http.post(urls.API_URL + urls.MEMBERS, payload)
          .pipe(catchError(errorHandl));
    
      }
    
      getMembers(queryParams?: any) {
        const params = new HttpParams({ fromObject: queryParams});
        return this.http.get(urls.API_URL + urls.MEMBERS, {params})
          .pipe(catchError(errorHandl));
      }

      getPickerMembers(queryParams?: any) {
        const params = new HttpParams({ fromObject: queryParams});
        return this.http.get(urls.API_URL + urls.MEMBERS + urls.PICKER, {params})
          .pipe(catchError(errorHandl));
      }

      searchMembers(queryParams?: any) {
        const params = new HttpParams({ fromObject: queryParams});
        return this.http.get(urls.API_URL + urls.SEARCH_MEMBERS, {params})
          .pipe(catchError(errorHandl));
      }
    
      getMemberById(id: any) {
        return this.http.get(urls.API_URL + urls.MEMBERS + `/${id}`)
          .pipe(catchError(errorHandl));
      }
      getMemberTripsbyId(id: any) {
        return this.http.get(urls.API_URL + urls.MEMBERS + `/${id}`)
          .pipe(catchError(errorHandl));
      }
      
}
